import { Button, makeStyles } from "@material-ui/core";
import { useNewMoralisObject } from "react-moralis";

const whitelistAddresses = [
"0xAd84F848Efb88C7D2aC9e0e8181861a995041D71",
"0x6Ad60bacf404935f5e934786Ca7e131AE53642AB",
"0xe977315fB1650192359c56A8eFD90B17Ff7Cc6F5",
"0x4cFD7de2825316cD9b9d03fA18842c41863c72EE",
"0x7Fc7BfC4b36EbA867B60b62b9BB8aEacF3822062",
"0xb681E52e4B22e3dC0B846228b8Dfa496ED8c2b5F",
"0x0c25c74b1017cB8830C8476372Fb28be826743C9",
"0x392Dc129d0FFe7D1ECdc79A73Ce9e4b938d83709",
"0xdbf37c5ae62bd82967cF4aF1e01FC4506CE9CB8A",
"0x12312dAf82C5aD5f5C1C7e28A48e8831b7e1DF3d",
"0x6b62BA1Cc3ee2469B9C8511FdcA31E56F327B75A",
"0x7b5f4aad61edAA53491810ebC62804169Bb3D3cD",
"0xb6281632Cfbd40035FCF0887bA5145d75721dcBf",
"0xf7d2EaDDBEdc13ee055C68f916885E5AcD231574",
"0x0b466175acC0a53e2aA75EADf59aBcC6b92aA6b6",
"0x49A6374A6D792b345f7029577a3b7BDaDb29cD80",
"0xe305B9052cEe1F0f437a4ff7CC6c2217EC680d26",
"0xef83a287ded45962997584174ddb2c68dc215e3b",
"0x14d381Ef2E4482415bBed654016B28566fC624D3",
"0x0dAE5FcaD0DF8E5C029D76927582DFBdFd7eeC79",
"0x923fC9eE70CCba05b6CbB2737961E1D775784576",
"0x3Dd60625FB3F9Cb3F083857e434a43a56DC3FaB9",
"0xC446Cd84A4AEdC194799a922cBc5727C14738234",
"0xD6792DF4E2D5cccFb4962030bA3Fce4628E5266f",
"0x1C6b1e494afc183c106795fd9542fF7E66f12935",
"0xa385d9367Df02d05f72A5ee0877C5Ba6b7Bf2BA6",
"0x3C8B757D45f152f49dCC9A7B870db32368D831B2",
"0xe16d756B1E27CABc43c8C4cAdD68004aB50452b2",
"0xC3F20cD67E9d833BC56b400A4319b05C5CE24944",
"0xB23EB4EFB463BD20CBFE59A9E2A18d8fBEaD9C31",
"0x97Ccb2DB265fA5EBA774cB609A4F7A625c286856",
"0xE6Da94F2e6E476d5Aa802494D1420627295D1299",
"0x886f9aB1b54d9eBaf7031d930B8C653B18b59688",
"0x3f6249c4d782aab00b5e9ab99e090035b80e0c15",
"0xe220E93176524D2B2E1C477F9875dd1d79C943f3",
"0x75784B13B289b8773218940A6DEe6162d53E07D3",
"0x2107B6b68BBfC27aeF9EE0EdCA97E7192df4BdF5",
"0x4a12850573836260d8103134698e343e42af77a3",
"0x75462a1041ef175754317C2a03cf12A351e63BC6",
"0xd80090c6c6e45ee8ae141215ead4cb63baa9882c",
"0xFe354c7521da9302A9A002d0717323C3BF28e992",
"0x8dc863127527781b995fa0C41168638e398e9465",
"0x4B91909484296dfdC302996708cAcaEc99fda7B8",
"0xeE355f5A154Fe3D3727999520963A3276Bf9A2b3",
"0x1dEc530a07c8f1C16BEF63B763A99407835c2C25",
"0x7d352658b7fEC49AFECAe3EB8DEbfD0B0Fc82Bb1",
"0x21641979DE54736732CeD12fB9F12c6F9Ae2B803",
"0x27cf7b699114Db0eb5f2123c85DF4141C54A15dF",
"0x7f58C60ce6331C4E159F6869380C9DEE5a73E73E",
"0xCB117A6C52f2830dFa9F4c7103E9Ad09bB880CD4",
"0xBC9c7D14055ce54BBd8fd5F4873dBf54B055b961",
"0xba4ed476bd06b6c3aaf3d04063c153fa96ade476",
"0x7757d5e835eeff8c6fd3eebd5c47a869e99c518f",
"0x52139433A54cFE1913d6436E9516561536EDE97D",
"0x1AE21F0BB7f204EDb156185a067Ded5BC2bb03d2",
"0xD81Cd16ddcdeD56bf1229DC65A5A46391fa9C17B",
"0x04ab2090d3aA89f7804794E3822DdA7a3d46af33",
"0x8970Dc7C3d173391B30b48f882a639D60640b360",
"0xBc00779F471D473E6770e2b6532a89Ab1387E022",
"0x7cb2F06E01697f56A38E0Da8b9dF5aB1D714FA4E",
"0x3ecdc2c20ff58039EF29a965475b1Ae0ec3B163C",
"0x21FF9c6882d83246AFfC50DaE5727C751EBc3A7B",
"0x0fD6158F72893c432F422c68759c93Ad31f9F34f",
"0xA4B01De1F831e533CB26458962115493E1FC421B",
"0x8cb1f920e437791a97443cc81b62476120d30e40",
"0x081794bf52f18f781b4c4c1427d928fdefbb5ba5",
"0x372c8962Aa0c9B3A23207183CAe5c1d3780d6B06",
"0xDd4F190D104f89e3B5c937B92afA65048F2c7F33",
"0x18fc46bFE8B633948A2775797c09386ad5b6c428",
"0x2D0EfE5e80b6A2160998303cb9e808D7aa6772Ab",
"0x84D1A141125A545C7E2037D15305CEFA900F4261",
"0xF6326C426560378002920C48eD7cA0b9063e2586",
"0x31337DEAA803E9919E77174eff9bD032184030d3",
"0x7535f7899859f7bd35C31Ab4dC6F9347ADa16dd2",
"0x07cE3bb422a537693aFD130259E5D3bD0dAC7479"
];
  
const useStyles = makeStyles({
  button: {
    height: 50, 
    width: 120, 
    color: '#030303',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: 20,
    backgroundColor:'#F4BF1A',
    "&:hover": {
      background: "#B58B07"
    },
    // "&:active": {
    //   background: "aqua"
    // }
  }
});

const AllowListButton = () => {
  const classes = useStyles();
  const { save } = useNewMoralisObject("AllowList");

  const saveObject = async () => {
    const data = {
      allowlist: whitelistAddresses
    };
    save(data, {
      onSuccess: (data) => {
        console.log(data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }

  return (
    <div>
      <Button className={classes.button} onClick={saveObject}>Add AllowList</Button>
    </div>)
}

export default AllowListButton;